<div #splashScreen id="splash-screen">
  <!--<img style="width: 120px;" src="./assets/image/logo_dark.png" alt="LIS" />-->
  <svg class="splash-spinner" viewBox="0 0 50 50">
    <circle
      class="path"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke-width="5"
    ></circle>
  </svg>
</div>
